// Utilitários de máscara para formulários

/**
 * Aplica máscara de CPF (000.000.000-00)
 */
export const maskCPF = (value) => {
  const numbers = value.replace(/\D/g, '');
  if (numbers.length <= 11) {
    return numbers
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
  }
  return value;
};

/**
 * Aplica máscara de CNPJ (00.000.000/0000-00)
 */
export const maskCNPJ = (value) => {
  const numbers = value.replace(/\D/g, '');
  if (numbers.length <= 14) {
    return numbers
      .replace(/(\d{2})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1/$2')
      .replace(/(\d{4})(\d{1,2})$/, '$1-$2');
  }
  return value;
};

/**
 * Aplica máscara de CPF ou CNPJ baseado no tamanho
 */
export const maskCPFCNPJ = (value) => {
  const numbers = value.replace(/\D/g, '');
  if (numbers.length <= 11) {
    return maskCPF(value);
  }
  return maskCNPJ(value);
};

/**
 * Aplica máscara de telefone (XX) XXXXX-XXXX ou (XX) XXXX-XXXX
 */
export const maskPhone = (value) => {
  const numbers = value.replace(/\D/g, '');
  if (numbers.length <= 10) {
    // Telefone fixo (XX) XXXX-XXXX
    return numbers
      .replace(/(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{4})(\d{1,4})$/, '$1-$2');
  } else {
    // Celular (XX) XXXXX-XXXX
    return numbers
      .replace(/(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{5})(\d{1,4})$/, '$1-$2');
  }
};

/**
 * Aplica máscara de CEP (00000-000)
 */
export const maskCEP = (value) => {
  const numbers = value.replace(/\D/g, '');
  if (numbers.length <= 8) {
    return numbers.replace(/(\d{5})(\d{1,3})$/, '$1-$2');
  }
  return value;
};

/**
 * Aplica máscara de moeda (R$ 0.000,00)
 * Se o valor já for um número (vindo do banco), não divide por 100
 * Se for uma string formatada (digitada pelo usuário), divide por 100
 */
export const maskCurrency = (value) => {
  // Se o valor já é um número (vindo do banco), formata diretamente
  if (typeof value === 'number') {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2
    }).format(value);
  }
  
  // Se for string, trata como entrada do usuário (divide por 100)
  const numbers = value.replace(/\D/g, '');
  if (numbers === '') return '';
  
  const amount = parseFloat(numbers) / 100;
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2
  }).format(amount);
};

/**
 * Remove máscara e retorna apenas números
 */
export const unmask = (value) => {
  return value.replace(/\D/g, '');
};

/**
 * Converte valor formatado em moeda para número
 */
export const currencyToNumber = (value) => {
  const numbers = value.replace(/\D/g, '');
  return parseFloat(numbers) / 100;
};

/**
 * Formata telefone para exibição (sem DDD)
 * 9 caracteres: XXXXX-XXXX
 * 8 caracteres: XXXX-XXXX
 * Se tiver mais caracteres (com DDD), pega os últimos 9 ou 8 dígitos
 */
export const formatPhoneDisplay = (value) => {
  if (!value) return '-';
  
  // Remove todos os caracteres não numéricos
  const numbers = value.replace(/\D/g, '');
  
  if (numbers.length === 0) return '-';
  
  // Determina quantos dígitos usar
  let phoneDigits;
  if (numbers.length >= 9) {
    // Se tiver 9 ou mais, pega os últimos 9 (celular)
    phoneDigits = numbers.slice(-9);
  } else if (numbers.length === 8) {
    // Se tiver exatamente 8, usa como está (fixo)
    phoneDigits = numbers;
  } else {
    // Se tiver menos de 8, retorna o valor original
    return value;
  }
  
  // Se tiver 9 caracteres: XXXXX-XXXX
  if (phoneDigits.length === 9) {
    return phoneDigits.replace(/(\d{5})(\d{4})$/, '$1-$2');
  }
  
  // Se tiver 8 caracteres: XXXX-XXXX
  if (phoneDigits.length === 8) {
    return phoneDigits.replace(/(\d{4})(\d{4})$/, '$1-$2');
  }
  
  // Se não se encaixar em nenhum padrão, retorna o valor original
  return value;
};

/**
 * Formata CPF/CNPJ para exibição
 * 11 caracteres: CPF (XXX.XXX.XXX-XX)
 * Mais de 11 caracteres: CNPJ (XX.XXX.XXX/XXXX-XX)
 */
export const formatCPFCNPJDisplay = (value) => {
  if (!value) return '-';
  
  // Remove todos os caracteres não numéricos
  const numbers = value.replace(/\D/g, '');
  
  if (numbers.length === 0) return '-';
  
  // Se tiver 11 caracteres ou menos: CPF
  if (numbers.length <= 11) {
    return maskCPF(numbers);
  }
  
  // Se tiver mais de 11 caracteres: CNPJ
  return maskCNPJ(numbers);
};




